var _defs, _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wishlist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 202,
    height: 192,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMoAAADABAMAAAC30OH9AAAAAXNSR0IB2cksfwAAABJQTFRFAAAAw51jAAAAgIAAw51jwppijAafUQAAAAZ0Uk5TAP8BAs00QBouoAAABCtJREFUeJztnN1x2zAQhCkreUviqIJMKnBSgScduwSX4BJcQGIpBWRsUeIPCN7hdkEcxsMQT7J98IddULYE3mrX1Bi7/4Fy6B+8npBf87V/dCQoh/ALkzOpljgi5RB/Q1ygWj1flUAZ1SMYqXpWPqeI01TMTIhYPqN8VzZBxiiQuDymyEoa5RJQIREmoqgQ+dLRq6f1Uwo8za6eiJ9SEg4IniWrJ/UTys/n5LRIjFEd1oeUtAOxGKs6rA8phgORGLM6qA8ozOKQ6qA+oDCLg6rH+pFCLQ6qHusHys0tszhMylA/UMjFQdVD/UDBFtdTQCm9mJ6CLu46C7N3XFZPQRfXzQLXFFHwaUdmTX19FgWv7sR0FHxx7axMCjPtSBnWic+gMNVNc/fYU5jFvZ44ysXi9gE17fVEGdbsXnIozV/4KXkdx47CLY4ddSjnjWkpnGH4+PFUg9KNjuJr2OUZVouy/1KDgm/L/l8W5fzXwn3zO4r3tqyKsnupQWmOO//N3yjvmOJ/iW2UjbJRNspGeT+U9tWFP6V9pbQmiv9/5DqUu8calPb9y5oo/hdZFcr1nfiaKN7bf/9Qg3I9U1oFpT/rcz8eWw2lP0/uNqY7mnOmOI0qlPGc33Nj6lDG+y+/fPY9ojhuTHDHqg7FcWO+PdWghPcr/SyrQpne4fWy7Pa5BmV6T9zs1Mgb0f19p42JKB8+u1DijgifjYkpLpbNekjqUFwsm3fdOFDa13sRxcEyoU/JgSL1XBW37OaPQCkuRuxSK04JWqe4nitmBIY5UpTuwcKWaZ2QZcW4Uvr3J5NWQ6ZHkRp6h2pBy6KuyfqUgpalOoeLiYl6Zp0oyV7rYpalO7oLiYmbjPFea2YYPfBlulZm/dJxd/oSy4ZGFpNSxLJ5h3n8jQL7DyQgCoiZ9+TrlOwjJiFfMM9ZLLYMSqYstWz/G6EsFSMFMsD8CzGkcIlAwVucpSFmS6TE0CLL4PTTEsvkpBSWfsLH/QNMWSBGDhbJebFsMUq0TKZki1GiWEj2DR9aSk6hZIrRUmVaWjBLjBr40yhaOC051ByeRvn4iYfo2UU7X4mPRKRQ/QG9/4kYpp5IpcUkQpg6hRUznu0wFFZMd6jLUjgxKSnJpDAdDcmiMGKSUtKpZ0JMalcMCi4mLcVIcMNi0lIMCnpkbkix0ujgXQZDikXBXgFaUiwKdgEknysIBbkA7Oy9SQHEmFJsii0G+BgBm2KKsaUAFCJCvYRiiAGkIBQyPZ5LSR7OIFIgSsozSApGSXgGSQEpqhj5rVcmRROD+QVTFDGYXzBFxqBSYIroGSoFpwhiYCk4BflQkwKUGQb2i6JEnhFSGIr9YTNFKJO/mowUihJ6RkE4SuAZ4xdLGTCcFJbSe8ZJYSld2xwJoSkXz0i/MiitZ6wUnnLG0JAMSs54AwIlO9Biu+CCAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 27,
    y: 31
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistFull);
export default __webpack_public_path__ + "static/media/wishlist_full.fba35fac610ea034d765c00b41bb4946.svg";
export { ForwardRef as ReactComponent };